module.exports = __webpack_public_path__ + "img/image_8.4fcd7fe7.png";